<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="900px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        :block="$vuetify.breakpoint.smAndDown"
        color="hrissecondary"
        class="white--text"
        v-on="on"
      >
        Create Position
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Position"
      text="Create Position"
      class="mb-0"
    >
      <form>
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>

            <v-col cols="12">
              <v-autocomplete 
                v-model="jobGrade"
                v-validate="'required'"
                :items="jobGrades"
                label="Job Grade Code"
                item-text="name"
                item-value="id"
                :error-messages="errors.collect('jobGrade')"
                data-vv-name="jobGrade"
                data-vv-as="job grade code"
              />
            </v-col>

            <v-col cols="12">
              <span> Require provide justification if late in/early out? </span>
              <v-radio-group
                v-model="requireJustification"
                class="mt-0"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
              </v-radio-group>
            </v-col>

            <v-col cols="12">
              <span> Employees assigned to this position are entitled with claim and claim through this system? </span>
              <v-radio-group
                v-model="hasClaim"
                class="mt-0"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
              </v-radio-group>
            </v-col>
          </v-row> 
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          class="px-10"
          @click="closeDialog"
        >
          Close
        </v-btn>
        <v-btn
          color="hrissecondary"   
          class="white--text px-10"       
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      return {
        progressing: false,
        dialog: false,
        name: '',
        jobGrade: null,
        jobGrades: [],
        requireJustification: 0,
        hasClaim: 0,
      }
    },
    mounted () {
      this.loadJobGrades()
    },
    methods: {
      loadJobGrades () {
        this.$api.jobGrades().list()
          .then(res => {
            this.jobGrades = res.data
          })
      },
      closeDialog () {
        this.name = ''
        this.jobGrade = null
        this.requireJustification = 0
        this.hasClaim = 0
        this.dialog = false
        this.$validator.reset()
      },
      submitForm () {
        this.progressing = true

        this.$api.positions().create({ 
          name: this.name,     
          job_grade_id: this.jobGrade,   
          require_justification_for_late_in_or_early_out: this.requireJustification,
          has_claim: this.hasClaim,
        })
          .then(() => {
            this.$snack({ message: 'Created successfully!' })
            this.closeDialog()
            this.$emit('created')
          })
          .catch(() => {
            this.$snack({ color: 'error', message: 'Failed to create position!' })
            this.progressing = false
          })          
      },
    },
  }
</script>
